var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"mb-5 banner-wrapper d-block",attrs:{"href":_vm.url}},[_c('img',{attrs:{"src":_vm.image,"width":"100%","height":"auto"}})])}
var staticRenderFns = []

export { render, staticRenderFns }